var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrisisPeak = function SvgCrisisPeak(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16,
    fill: "none",
    viewBox: "0 0 19 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3.5 13.9A8.31 8.31 0 0 1 3.5 2m11.67 11.9a8.31 8.31 0 0 0 0-11.9M6.42 4a4.82 4.82 0 0 0-2.09 3.95c0 1.63.83 3.07 2.09 3.95m5.83 0a4.82 4.82 0 0 0 2.09-3.95c0-1.62-.83-3.06-2.09-3.95",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.34 12.54a.83.83 0 1 0 0-1.67.83.83 0 0 0 0 1.67Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.33 5.04V9.2",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgCrisisPeak;